import DOMPurify from 'dompurify';
import parse, { domToReact } from 'html-react-parser';
import React from 'react';

import { Text, TextProps } from '@coinflare/ui/core';

type AvailableTags = 'h1' | 'h2' | 'p';
type TagMapStyles = Partial<Record<AvailableTags, TextProps>>;

interface RichTextMapperProps {
    content: string;
    tagMapStyles?: TagMapStyles;
}

const generateTagMap = (props?: TagMapStyles) => {
    return {
        h1: (domNode: any) => (
            <Text {...(props?.h1 ?? { variant: 'h5' })}>{domToReact(domNode.children)}</Text>
        ),
        h2: (domNode: any) => (
            <Text {...(props?.h2 ?? { variant: 'h5' })}>{domToReact(domNode.children)}</Text>
        ),
        p: (domNode: any) => (
            <Text {...(props?.p ?? { variant: 'p2' })}>{domToReact(domNode.children)}</Text>
        ),
        // Add other tags and their corresponding Typography variants (optionally pass desired tag styles as props)
    };
};

const sanitizeHtml = (html: string) => {
    return DOMPurify.sanitize(html);
};

export const RichTextMapper = ({
    content,
    tagMapStyles = {} as TagMapStyles,
}: RichTextMapperProps) => {
    const sanitizedContent = sanitizeHtml(content);
    const tagMap: any = generateTagMap(tagMapStyles);

    const options = {
        replace: (domNode: any) => {
            if (domNode.type === 'tag' && tagMap[domNode.name]) {
                return tagMap[domNode.name](domNode);
            }
        },
    };

    return typeof sanitizedContent === 'string' ? <>{parse(sanitizedContent, options)}</> : <></>;
};
